/* ============================================
   PLACE CLAIRE — theme.js
   ============================================ */

/* ===== MOBILE MENU ===== */
function toggleMobileMenu() {
  const menu = document.getElementById('mobile-menu');
  const isHidden = menu.hidden;
  menu.hidden = !isHidden;
  document.body.style.overflow = isHidden ? 'hidden' : '';
}

/* ===== CART DRAWER ===== */
function toggleCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  drawer.hidden = !drawer.hidden;
  document.body.style.overflow = drawer.hidden ? '' : 'hidden';
}

/* Update cart item quantity */
function updateCart(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(r => r.json())
  .then(() => window.location.reload());
}

/* ===== LANGUAGE MODAL ===== */
function openLangModal() {
  const modal = document.getElementById('lang-modal');
  modal.hidden = false;
  document.body.style.overflow = 'hidden';
}

function closeLangModal() {
  const modal = document.getElementById('lang-modal');
  modal.hidden = true;
  document.body.style.overflow = '';
}

/* Close on Escape key */
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeLangModal();
    const drawer = document.getElementById('cart-drawer');
    if (drawer && !drawer.hidden) {
      drawer.hidden = true;
      document.body.style.overflow = '';
    }
    const menu = document.getElementById('mobile-menu');
    if (menu && !menu.hidden) {
      menu.hidden = true;
      document.body.style.overflow = '';
    }
  }
});

/* ===== PRODUCT GALLERY ===== */
function setGallerySlide(index) {
  const slides = document.querySelectorAll('.product-gallery__slide');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  slides.forEach((s, i) => s.classList.toggle('active', i === index));
  thumbs.forEach((t, i) => t.classList.toggle('active', i === index));
}

/* ===== VARIANT SELECTOR ===== */
function selectOption(optionName, value) {
  // Update active state
  document.querySelectorAll(`[data-option="${optionName}"]`).forEach(btn => {
    btn.classList.toggle('active', btn.dataset.value === value);
  });

  // Build selected values from all option groups
  const selected = {};
  document.querySelectorAll('.option-btn.active').forEach(btn => {
    selected[btn.dataset.option] = btn.dataset.value;
  });

  // Find matching variant via Shopify product JSON
  if (window.__productVariants) {
    const match = window.__productVariants.find(v => {
      return v.options.every((opt, i) => {
        const key = v.option_names ? v.option_names[i] : Object.keys(selected)[i];
        return selected[key.toLowerCase().replace(/\s/g, '-')] === opt;
      });
    });
    if (match) {
      document.getElementById('variant-id-' + window.__productId).value = match.id;
      const atcBtn = document.querySelector('.product-info__atc');
      const priceEl = document.querySelector('.product-info__price-current');
      if (atcBtn) {
        atcBtn.disabled = !match.available;
        atcBtn.textContent = match.available
          ? atcBtn.dataset.addText
          : atcBtn.dataset.soldText;
      }
      if (priceEl && match.price) {
        priceEl.textContent = formatMoney(match.price);
      }
    }
  }
}

/* Simple money formatter */
function formatMoney(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}

/* ===== LEGAL TABS ===== */
function showLegalTab(id) {
  document.querySelectorAll('.legal-tab-content').forEach(el => el.classList.remove('active'));
  document.querySelectorAll('.legal-tab-btn').forEach(btn => btn.classList.remove('active'));
  const tab = document.getElementById('tab-' + id);
  if (tab) tab.classList.add('active');
  const btn = document.querySelector(`[onclick="showLegalTab('${id}')"]`);
  if (btn) btn.classList.add('active');
}

/* ===== FORM: ADD TO CART ===== */
document.addEventListener('submit', function(e) {
  const form = e.target;
  if (!form.dataset.productForm) return;
  e.preventDefault();
  const data = new FormData(form);
  fetch('/cart/add.js', { method: 'POST', body: data })
    .then(r => r.json())
    .then(() => {
      toggleCartDrawer();
    })
    .catch(err => console.error(err));
});
